import { useFt } from 'hooks'
import { constants } from 'helpers'
import { useCandleSubscription } from 'modules/subscription'

import TheEditBanner from 'compositions/banners/TheEditBanner/TheEditBanner'
import CandleSubscribeSmallBanner from 'compositions/banners/CandleSubscribeSmallBanner/CandleSubscribeSmallBanner'

import CleanFragrancesBanner from './components/CleanFragrancesBanner/CleanFragrancesBanner'


const Banner = () => {
  const isTheEditEnabled = useFt(constants.features.theEdit)

  const isCandleSubscriptionSearchBannerEnabled = useFt(constants.features.candleClubMoreBanners)
  const { candleSubscription, isFetching } = useCandleSubscription()

  if (isFetching) {
    return null
  }

  const isCandleSubscriptionBannerVisible = (
    isCandleSubscriptionSearchBannerEnabled
    && candleSubscription?.isEnabled
    && !candleSubscription.isSelected
  )

  if (isCandleSubscriptionBannerVisible) {
    return (
      <CandleSubscribeSmallBanner placement="Search" data-testid="searchBanner" withMobileCompensator />
    )
  }

  return isTheEditEnabled
    ? <TheEditBanner placement="Search" data-testid="searchBanner" />
    : <CleanFragrancesBanner />
}

export default Banner
